import type { ServiceHierarchyNode } from "../Domain/serviceNotificationHierarchy.types";

export function resolveNodeLabel(node: ServiceHierarchyNode, t: (k: string) => string): string {
  let base: string;
  if (node.labelKey) {
    base = t(node.labelKey);
  } else if (node.labelLiteral) {
    base = node.labelLiteral;
  } else {
    base = node.id;
  }

  if (node.appendAllSuffix) {
    return `${base}${t("_serviceNotificationHierarchy_parentAllSuffix")}`;
  }

  return base;
}
